export default (state = {}, action) => {

    switch (action.type) {

        case 'UPDATE_NOTIFICATION_REGION_REQUEST':
            return action.payload;

        default:

            return state;

    }

};